import { userService } from '../../helpers/services/user.service';
import { sharedHelper } from '@/utils'

export const state = {
  list: {
    data: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      lastPage: 0,
      tableRowsCount: 0
    }
  },
  details: {},
  status: {}
}

export const USER_MODULE = "user";

// define action 
export const GET_ALL_USERS = 'getAllUsers';
export const GET_USER = 'getUser';
export const GET_ALL_STAFF = 'getAllStaff';

// define mutation
const REQUESTING = "requesting";
const ALL_USER_SUCCESS = "allUserSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_USER_SUCCESS = "getUserSuccess";

export const actions = {

  // eslint-disable-next-line no-unused-vars
  [GET_ALL_USERS]({ commit }, { filter }) {
    userService
      .getAllUsers(filter)
      .then(
        (result) => {
          commit(ALL_USER_SUCCESS, { data: result })
        },
        (error) => {
          let message = sharedHelper.getErrorMessage(error);
          sharedHelper.alertErrorMessage(message, error.response.data.code)
          commit(FAILURE);
        }
      )
  },

  // eslint-disable-next-line no-unused-vars
  [GET_ALL_STAFF]({ commit }, { filter }) {
    userService
      .getAllStaffs(filter)
      .then(
        (result) => {
          commit(ALL_USER_SUCCESS, { data: result })
        },
        (error) => {
          let message = sharedHelper.getErrorMessage(error);
          sharedHelper.alertErrorMessage(message, error.response.data.code)
          commit(FAILURE);
        }
      )
  },

  // eslint-disable-next-line no-unused-vars
  async [GET_USER]({ commit }, { id }) {
    await userService
      .getUser(id)
      .then(
        (result) => {
          commit(GET_USER_SUCCESS, result)
        },
        (error) => {
          let message = sharedHelper.getErrorMessage(error);
          sharedHelper.alertErrorMessage(message, error.response.data.code)
          commit(FAILURE);
        }
      );
  },

};

export const mutations = {

  [ALL_USER_SUCCESS](state, { data }) {
    let d = data.data

    state.list.data = []
    state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

    if (data.success) {
      let list = []

      d.forEach((x) => {
        list.push({
          id: x.id,
          firstName: x.first_name,
          lastName: x.last_name,
          email: x.email,
          phone: x.phone,
          chineseName: x.chinese_name,
          image: x.image,
          companyIhextarUser: x.company_ihextar_users,
        })
      })

      state.list.data = list
    }
  },
  [SUCCESS](state) {
    state.status = {};
  },
  [FAILURE](state) {
    state.status = {};
  },
  [REQUESTING](state) {
    state.status = { processing: true };
  },
  [GET_USER_SUCCESS](state, data) {
    let x = data.data
    state.details = {
      id: x.id,
          firstName: x.first_name,
          lastName: x.last_name,
          email: x.email,
          phone: x.phone,
          chineseName: x.chinese_name,
          image: x.image,
          companyIhextarUser: x.company_ihextar_users,
    }

  },
}


